import jwtDecode from "jwt-decode"
import humps from "humps"

const accessToken = useLocalStorage<string | null>(
  "group-access-token",
  null
)

type MerchantGroupTokenClaims = {
  merchantGroupId: string
  merchantGroupAdminId: string
}

const tokenClaims =
  computed<MerchantGroupTokenClaims | null>(() =>
    accessToken.value
      ? humps.camelizeKeys<MerchantGroupTokenClaims>(
          jwtDecode(accessToken.value)
        )
      : null
  )

const isLoggedInMerchantGroup = computed(
  () => !!tokenClaims.value
)

const setToken = (value: string | null) => {
  accessToken.value = value
}

export const useMerchantGroupAuth = () => ({
  accessToken,
  isLoggedInMerchantGroup,
  setToken,
})
